/* MK 2 oct. 2026 — Espace client : ouvrir/fermer le détail des commandes, onglets, nombre de favoris. */

  (function () {
    var roots = document.querySelectorAll('[data-mk-acc]');
    roots.forEach(function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mk-acc-toggle]');
      if (!b) return;
      var d = document.getElementById(b.getAttribute('aria-controls'));
      if (!d) return;
      var open = d.hidden;
      d.hidden = !open;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? b.getAttribute('data-label-close') : b.getAttribute('data-label-open');
    });
    var tabs = root.querySelectorAll('.mk-acc__nav a[href^="#"]');
    tabs.forEach(function (a) {
      a.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        a.classList.add('is-active');
      });
    });
    var wc = root.querySelectorAll('[data-mk-acc-wishlist-count]');
    if (wc.length) {
      var n = 0;
      try { n = (JSON.parse(localStorage.getItem('mk_favorites')) || []).length; } catch (e) {}
      wc.forEach(function (el) { if (!el.hasAttribute('data-sample')) el.textContent = n; });
    }
    });
  })();
